import * as gfunctions from '../../../js/generalFunctions';
/* eslint-disable */
CCL.editGuestSnorkel = {
  autoload: [
    ['submitData', $('.saveEditGuest_Transfers').length > 0]
  ],
  submitData() {
    $('body').on('click', '.saveEditGuest_Transfers', (event) => {
      gfunctions.showLoader();
      const guestsId = [];
      const productId = event.target.dataset.productid;
      const preSalesId = event.target.dataset.presalesid;
      let wheelchair = false;
      if ($(`.card-${preSalesId} .is-wheelchair`).length) {
        wheelchair = $(`.card-${preSalesId} .is-wheelchair`)[0].dataset.wheelchair === 'true' ? true : false;
      }
      $.each($(`.card-${preSalesId} .custom-control.custom-checkbox.box-inputs input`), (i, element1) => {
        if (element1.checked) {
          const gId = element1.dataset.guestid;
          guestsId.push(gId);
        }
      });
      const ajaxObj = {
        productId,
        guestsId,
        preSalesId,
        wheelchair
      };
      const token = $('#csrfSessionToken').data('csrf');
      gfunctions.showLoader();
      $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: '/shop/cart/transfer/updateTransfersSelection',
        // url: '/_ui/responsive/ccl/assets/templates/airport-transfers/edit-guest-airport-transfers.json',
        dataType: 'json',
        data: JSON.stringify(ajaxObj),
        headers: {
          CSRFToken: token
        }
      }).done((res) => {
        gfunctions.hideLoader();
        if (!res.addedGuestCount || res.addedGuestCount === 0) {
          $(`.card-${preSalesId}`).remove();
        }
        this.updateHtml(res, preSalesId);
        gfunctions.updateCouponSummary(res.conflictResponse);
        this.showEditGuests(preSalesId, res);
      }).fail(() => {
        gfunctions.hideLoader();
        console.log('error Occured');
      });
      const parentElement = $(event.currentTarget).parents('.edit-guest-snorkel-wrap');
      setTimeout(() => {
        parentElement.siblings('.edit-guest-snorkel-link').focus();
        parentElement.siblings('.edit-guest-snorkel-link').addClass('ada-element-focus');
        parentElement.siblings('.edit-guest-snorkel-link').attr('aria-expanded', 'false');
      }, 700);
    });

    // $('.cancelEditGuest_Transfers').on('click', (event) => {
    $('body').on('click', '.cancelEditGuest_Transfers', (event) => {
      gfunctions.showLoader();
      const ajaxObj = {
        productId: event.target.dataset.productid,
        preSalesId: event.target.dataset.presalesid
      };
      gfunctions.showLoader();
      const token = $('#csrfSessionToken').data('csrf');
      $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: '/shop/cart/transfers/productDetails',
        dataType: 'json',
        data: JSON.stringify(ajaxObj),
        headers: {
          CSRFToken: token
        }
      }).done((res) => {
        gfunctions.hideLoader();
        const { presalesid } = event.target.dataset;
        this.updateHtml(res, presalesid);
      }).fail(() => {
        gfunctions.hideLoader();
        console.log('error Occured');
      });
      const parentElement = $(event.currentTarget).parents('.edit-guest-snorkel-wrap');
      setTimeout(() => {
        parentElement.siblings('.edit-guest-snorkel-link').focus();
        parentElement.siblings('.edit-guest-snorkel-link').addClass('ada-element-focus');
        parentElement.siblings('.edit-guest-snorkel-link').attr('aria-expanded', 'false');
      }, 700);
    });
  },
  showEditGuests(productId, data) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/airport-transfers/edit-guest-airport-transfers.html'
    }).done((response) => {
      gfunctions.hideLoader();
      const timeSlots = data.conflictResponse.timeSlotsCard;
      for (let i = 0; i < timeSlots.length; i++) {
        const presales = timeSlots[i].transferInformation.preSaleId;
        timeSlots[i].transferInformation.productId = data.conflictResponse.productCard.productId;
        timeSlots[i].giftGiverFlow = data.giftGiverFlow;
        const bookingData = timeSlots[i];
        const html = gfunctions.createDynamicHTML(response, bookingData);
        const repanitClass = `.edit-guest-snorkel-wrap.edit-guest-transfers-${presales}`;
        $(repanitClass).empty().append(html);
      }
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('Something went wrong while loading dynamic HTML');
    });
  },
  updateHtml(response, presalesid) {
    gfunctions.hideLoader();

    const repanitClass = `.edit-guest-snorkel-wrap.edit-guest-transfers-${presalesid}`;
    const $imgArrowIcon = $(`.c-cart-card.card-${presalesid}`).find('.list-item.edit-guest-snorkel-link');
    $imgArrowIcon.removeClass('open');
    $(repanitClass).slideToggle();

    gfunctions.updateCartSummary(response.orderSummary);
    gfunctions.updateProductSummary(response.orderSummary);
    if (response.cartEmpty) {
      window.location.reload();
    }
    if ($(`.card-${presalesid} .list-item.no-persons span`).length) {
      $(`.card-${presalesid} .list-item.no-persons span`)[0].innerText = response.addedGuestCount;
    }
    $.each($(`.card-${presalesid} .custom-control.custom-checkbox.box-inputs input`), (i, element1) => {
      element1.checked = false;
      $.each(response.guestInformation, (index, value) => {
        // const newGuestId = `${value.bookingId}_${value.guestId}`;
        if (element1.dataset.guestid === value.guestId) {
          element1.checked = value.guestAdded;
        }
      });
    });
  }
};




// WEBPACK FOOTER //
// ./src/app/components/c-edit-guest-airport-transfers/edit-guest-airport-transfers.js